import React, {useState, useEffect} from 'react'
import expand_forecast from '../assets/expand_forecast.svg'
import { Collapse } from 'antd';
import DragExpenses from './DragExpenses';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
const { Panel } = Collapse;
function ForecastDropDown({expanded, entry,expenseFormatted,budgetFormatted,genExtra, parent, contracted, forecasted, spent}) {
    const [expand, setExpand] = useState(['0', '1']);
    useEffect(() => {
        if(expanded){
            setExpand(['0', '1'])
        }else{
            setExpand(['0'])
        }
      }, [expanded])

      const onPanelChange = (panelKey) => {
        console.log(panelKey)
        setExpand(panelKey);
      };
    return (
    <div className='forecast'>
        <Collapse
        activeKey={expand} 
        onChange={onPanelChange}
                expandIconPosition='end'
                size='small'
                expandIcon={({ isActive }) => <img className={isActive ? 'expand_forecast' : 'expanded_forecast'} src={expand_forecast} alt='#' />}
            >
                <Panel
                    header={<div style={{marginTop:'2px'}}>
                        <div className='forecast-name' >
                            &nbsp;
                            <span style={{ marginBottom: '5px' }}>{entry.BudgetLineName}</span>
                        </div>
                        <div className='forecast-value'>
                        <Tooltip title="Actuals (Actuals % Forecasted)" placement="bottom">
                            <span style={{color: Math.round(spent) > Math.round(forecasted) ? '#D6405B' : '#377199'}}>
                                {/** actuals (actuals % forecasted) */}
                            {Math.round(spent).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {forecasted ? ' ('+Math.round(spent ? spent/forecasted*100 : 0)+'%)' : ''}
                            </span>
                            </Tooltip>
                            &nbsp;|&nbsp;
                            <Tooltip title="Forecasted">
                            {/* forcasted  */}
                            {Math.round(forecasted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            {/** contracted ? ' ('+Math.round(forecasted ? forecasted/contracted*100 : 0)+'%)' : ''*/}
                            </Tooltip>
                        </div>
                    </div>}
                    key="1"
                    extra={genExtra(entry,true)}>
                    <div className='expense-drop-forecast'>
                    <DragExpenses 
                    expenses={expenseFormatted[entry.BudgetLineID]} 
                    truncate={false}
                    droppableID={entry.BudgetLineID+''}/>
                    {/** 
                     * <div className='forecast-placeholder'>
                    </div>
                    */}
                    
                    </div>
                    
                </Panel>
            </Collapse>
    </div>
  )
}

export default ForecastDropDown